import {
  faCircleCheck,
  faCircleInfo,
  faTriangleExclamation,
  faSkull,
} from '@fortawesome/free-solid-svg-icons';

import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export type StatusModalState = 'error' | 'success' | 'info' | 'warning';

export interface StatusModalConfig {
  title: string;
  icon: IconDefinition;
}

export interface StatusModalData {
  state: StatusModalState;
  message: string;
  title?: string;
  highlights?: string[];
}

export const STATUS_MODAL_CONFIG: Record<StatusModalState, StatusModalConfig> = {
  error: {
    title: 'Error',
    icon: faSkull,
  },
  success: {
    title: 'Success',
    icon: faCircleCheck,
  },
  info: {
    title: 'Info',
    icon: faCircleInfo,
  },
  warning: {
    title: 'Warning',
    icon: faTriangleExclamation,
  },
};
